"use strict";
var editor_2d = require("editor-2d");
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var GridInteractionView = require("./../../../interactionViews/gridInteractionView.js");
var drawRectangleDataTo2D = require("./../../../view/renderData/drawRectangleDataTo2D.js");

var RectInteractionView = function (editorView, interactionModel, parentGroup, layers, config, getAttributes) {
    var self = this;
    this.editorView = editorView;
    this.gui = this.editorView; // TODO: legacy
    this.interactionModel = interactionModel;
    this.data = interactionModel.data;
    this.getAttributes = getAttributes;

    this.cameraModel = this.editorView.editorModel.cameraModel();

    this.initGroups(parentGroup, [layers.draw, layers.control]);

    this.drawGroup = this.editorView.svg.group(this.getGroupInfo(layers.draw).svgGroup);
    this.controlGroup = this.getGroupInfo(layers.control).svgGroup;

    if(layers.interaction) this.addGridInteractionView(editorView, interactionModel, parentGroup, layers);

    $(this.controlGroup).mousedown(function (event) {
        var cEvent = self.getMouseDownEvent(event);
        return self.editorView.stateMachine.handle(cEvent);
    });

    this.interactionModel.selected.onChange(this, function (value) {
        self.setSelected(value);
    }, 10);

    this.data.onBubble(this, function () {
        self.editorView.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self);
    }, 10);

    this.cameraModel.viewS.onChange(self, function () {
        self.editorView.heavyHandler.scheduleHeavy('resize_control', self.resizeControl, self, [], self);
    }, 10);

    this.draw();
};
lib_core.mixin(RectInteractionView, editor_2d.DrawingElement);
lib_core.mixin(RectInteractionView, GridInteractionView);

module.exports = RectInteractionView;

RectInteractionView.prototype.draw = function () {
    $(this.drawGroup).empty();
    $(this.controlGroup).empty();

    if (!this.data.isAlive()) return;

    var attrs;
    if(this.getAttributes) attrs = this.getAttributes();

    // draw visible
    drawRectangleDataTo2D(this.editorView.svg, this.drawGroup, this.data, attrs);

    // draw control
    drawRectangleDataTo2D(this.editorView.svg, this.controlGroup, this.data);
    this.control = $(":nth-last-child(1)", this.controlGroup);
    this.resizeControl();
};

RectInteractionView.prototype.resizeControl = function (event) {
    if(this.control) this.control.attr("stroke-width", this.data.strokeWidth() + 4 / this.cameraModel.viewS());
};

RectInteractionView.prototype.getMouseDownEvent = function (event) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)
        .fromJSEvent(event)
        .element(this.interactionModel)
        .data('mouseCoord', this.editorView.relativeMouseCoord(event));
    return cEvent;
};
